module.exports = {
    siteUrl: "https://kevincittadini.dev",
    title: "Kevin Cittadini - Software Engineer",
    description: "Kevin's blog about technology, design patterns, programming and more.",
};
